import React from "react";
import classNames from "lib/classNames";

const GuideContainer = ({
  title,
  children,
  className = "",
  link = "",
  linkLabel,
  styles = {},
  itemsClassName = "",
  itemsStyles = {},
}) => {
  return (
    <div
      className={classNames(
        "shadow-sm px-5 pt-5 bg-white rounded relative",
        className
      )}
      style={{ ...styles, paddingBottom: "50px" }}
    >
      <h4
        className={classNames(
          "flex-1 capitalize text-gray-600 text-md font-bold"
        )}
      >
        {title}
      </h4>
      <div
        className={classNames("w-full my-4", itemsClassName)}
        style={itemsStyles}
      >
        {children}
      </div>
      <div
        className={classNames(
          "w-full absolute flex items-center justify-center"
        )}
        style={{ bottom: "31px" }}
      >
        <a
          className={classNames("capitalize text-gray-600 text-md font-bold")}
          style={{
            bottom: "31px",
            textDecoration: "underline",
            lineHeight: "22px",
          }}
          href={link}
          target="_blank"
        >
          {linkLabel}
        </a>
      </div>
    </div>
  );
};

export default GuideContainer;
